<template>
  <div class="sort-icon" :class="[ direction ]">
    <Chevron class="up" />
    <Chevron class="down" />
  </div>
</template>

<script setup lang="ts">
import Chevron from '@images/chevron.svg?component';

defineProps({
  direction: {
    type: String,
  },
});
</script>

<style lang="scss" scoped>
.sort-icon {
  @apply flex flex-col items-center justify-between;
  @apply text-dark w-4 h-4;

  &.asc, &.desc {
    @apply justify-center;
  }

  &.asc .down {
    display: none;
  }
  &.desc .up {
    display: none;
  }

  :deep(svg) path {
    @apply fill-current;
  }
}

.up,
.down {
  @apply w-3;
}

.up {
  @apply transform rotate-180;
}

.active {
  @apply text-dark;
}
</style>
